module.exports = __webpack_public_path__ + "static/media/005-dentist chair.e76cb24f.svg";